module.exports = __webpack_public_path__ + "static/media/trust.897efc79.svg";